'use strict';

exports.__esModule = true;

var _DropdownMultiSelect = require('./DropdownMultiSelect');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DropdownMultiSelect).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];